import React from 'react';
import Immutable from 'immutable';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { DownloadButton } from '../../../components';
import { MediaDocument } from '../../../types/uncinc_profile/media';

interface DocsByThemeProps {
  entities: Immutable.List<ImmutableEntity<MediaDocument>>;
}

const DocsByTheme: React.FC<DocsByThemeProps> = ({ entities }) => (
  <div className="DocsByTheme">
    {entities.map((entity) => {
      const mediaDocument = entity.toJS().field_media_document[0];

      return (
        <DownloadButton
          title={mediaDocument.filename}
          size={mediaDocument.size}
          source={mediaDocument.source}
        />
      );
    })}
  </div>
);

export default DocsByTheme;
